import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

function Sidebar() {
    const [isCollapsed, setIsCollapsed] = useState(false); // State for toggle
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.clear();
        navigate('/');
        window.location.reload(); 
    };

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
            <div className="sidebar-header">
                {!isCollapsed && <img src='/assets/image.png' alt='iopex-logo' style={{width:'150px'}}/>}
                <button className="toggle-btn" onClick={toggleSidebar}>
                    <i className={`fa-solid ${isCollapsed ? 'fa-bars' : 'fa-bars'}`}></i>
                </button>
            </div>

            <nav className="sidebar-nav">
                {/* <NavLink to="/dashboard" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    <i className="fa-solid fa-chart-line"></i>
                    {!isCollapsed && <span>Dashboard</span>}
                </NavLink>
                <NavLink to="/playables" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    <i className="fa-solid fa-gamepad"></i>
                    {!isCollapsed && <span>Playables Coupons</span>}
                </NavLink>
                <NavLink to="/projects" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    <i className="fa-solid fa-wallet"></i>
                    {!isCollapsed && <span>Add to Wallet</span>}
                </NavLink> */}
                 <NavLink to="/staticplayabledashboard" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    <i className="fa-solid fa-gamepad"></i>
                    {!isCollapsed && <span>Static Playable</span>}
                </NavLink>
            </nav>

            <div className="sidebar-footer">
                <button onClick={handleLogout} className="nav-item logout-btn">
                    <i className="fa-solid fa-right-from-bracket"></i>
                    {!isCollapsed && <span>Sign Out</span>}
                </button>
            </div>
        </div>
    );
}

export default Sidebar;